<template>
  <v-row no-gutters>
    <feature-card-basic :layer="layer" @update:feature="featureFetched">
      <template #top v-if="collisionsVisible">
        <custom-collisions-info
          v-if="isFetched"
          :collisions-data="collisionsData"
          :additional-collisions="additionalCollisions"
        />
        <main-loader v-else />
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import FeatureCardBasic from '@/components/FeatureCardBasic';
import CustomCollisionsInfo from '@/components/CustomCollisionsInfo';
import MainLoader from '@/components/MainLoader';
export default {
  name: 'FeatureCardFixedAsset',
  components: { FeatureCardBasic, CustomCollisionsInfo, MainLoader },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    isAdminEnabled: get('admin/settingsValues@fixed_assets_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@FIXED_ASSETS_MODULE.enabled'),
    modulesPermissions: get('users/toolsPermissions@FIXED_ASSETS_MODULE'),
    fixedAssetsMapping: get('admin/modulesMapping@fixed_assets'),
    collisionsVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions;
    },
    currentFeatureId() {
      return this.$route.params.fid;
    },
    dataSourceName() {
      return this.layer?.data_source_name || '';
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    layerId() {
      return this.layer?.id || null;
    },
    permissions() {
      const value = this.modulesPermissions.main_value;
      return value > 0;
    },
    relations: get('relations/relations'),
    relationsList() {
      return this.relations?.[this.dataSourceName]?.[this.currentFeatureId] || [];
    },
  },
  data: () => ({
    additionalCollisions: {},
    collisionsData: [],
    fixedAssetsDataSources: {
      waterPipes: {
        name: 'waterPipes',
        dataSourceSettingName: 'fixed_assets_water_pipes_datasource',
        attributeSettingName: 'water_pipes_attribute',
      },
      waterTerminals: {
        name: 'waterTerminals',
        dataSourceSettingName: 'fixed_assets_water_terminals_datasource',
        attributeSettingName: 'water_terminals_attribute',
      },
      sewerPipes: {
        name: 'sewerPipes',
        dataSourceSettingName: 'fixed_assets_sewer_pipes_datasource',
        attributeSettingName: 'sewer_pipes_attribute',
      },
      sewerTerminals: {
        name: 'sewerTerminals',
        dataSourceSettingName: 'fixed_assets_sewer_terminals_datasource',
        attributeSettingName: 'sewer_terminals_attribute',
      },
    },
    isFetched: false,
  }),
  methods: {
    featureFetched(feature) {
      const additionalCollisions = {};
      this.relationsList.forEach(relation => {
        const {
          data_source_name: dataSourceName,
          data_source_verbose_name: dataSourceVerboseName,
          feature_desc_attribute_value: descAttributeValue,
          feature_id: featureId,
          geometry,
        } = relation;
        if (!additionalCollisions[dataSourceName]) {
          additionalCollisions[dataSourceName] = { id: dataSourceName, name: dataSourceVerboseName, children: [] };
        }
        const { attributes, desc_attribute_name: descAttributeName } = this.dataSources[
          dataSourceName
        ].attributes_schema;
        const descAttributeVerboseName = attributes.find(attribute => attribute.name === descAttributeName)
          ?.verbose_name;
        additionalCollisions[dataSourceName].children.push({
          id: `${dataSourceName}-${featureId}`,
          geometry,
          name: `${descAttributeVerboseName}: ${descAttributeValue}`,
        });
      });
      this.additionalCollisions = Object.values(additionalCollisions);
      this.collisionsData = Object.values(this.fixedAssetsDataSources)
        .map(fixedAssetsDataSource => {
          const { attributeSettingName, dataSourceSettingName } = fixedAssetsDataSource;
          const attributeName = this.fixedAssetsMapping.fixed_assets_datasource.settings[attributeSettingName];
          const attributeValue =
            feature.properties[attributeName]
              ?.split(',')
              ?.filter(value => !!value)
              .map(value => parseInt(value)) || [];
          if (!attributeValue?.length) return null;
          const dataSourceName = this.fixedAssetsMapping[dataSourceSettingName].datasource;
          return { dataSourceName, attributeName: 'id', attributeValue, operator: '$IN' };
        })
        .filter(collisionData => !!collisionData);
      this.isFetched = true;
    },
  },
};
</script>
